<section class="sgi-section">

  <div class="sgi-container">

    <!-- ===== MENU IZQUIERDO ===== -->
    <aside class="sgi-sidebar">
      <a href="#" class="menu-item">OCC MUNDIAL</a>
      <a href="#" class="menu-item">BUZÓN DIGITAL ITSE</a>

      <a href="#" class="menu-item active">BUZÓN DIGITAL ITSE</a>
      <a href="#" class="menu-item gray">INNOVACIÓN Y CALIDAD</a>
    </aside>

    <!-- ===== CONTENIDO ===== -->
    <div class="sgi-content">

      <h2>SISTEMA DE GESTIÓN INTEGRAL (SGI)</h2>

      <!-- ICONO -->
      <br>
      <div class="sgi-icono">
        <img src="/assets/banners_carreras/logo_drive.png" alt="Drive">
        <a href="https://drive.google.com/drive/folders/1jmcNdkDJjNGivXkRxrQgJ2A97RNKCCB0" class="link-doc">Documentación Actual</a>
      </div>

      <!-- MISIÓN -->
      <h4>MISIÓN</h4>
      <p>
        Formar profesionistas competentes ofreciendo un servicio educativo integral de
        calidad certificada que permite mejorar el nivel de vida de la sociedad de una manera
        justa y equitativa contribuyendo al desarrollo sustentable de la región.
      </p>

      <hr>

      <!-- VISIÓN -->
      <h4>VISIÓN</h4>
      <p>
        Ser una institución líder en el Estado de Campeche, con un sistema de gestión integrado y
        una oferta educativa acreditada en todos sus niveles,
        que genere un impacto significativo en el desarrollo económico, laboral, social y cultural
      </p>

      <hr>

      <!-- POLÍTICA -->
      <h4>POLÍTICA INTEGRAL</h4>
      <p>
        El ITSE establece el compromiso de brindar un servicio educativo de calidad, implementando y mejorando
        continuamente sus procesos en armonía con el medio ambiente y la magnitud de sus riesgos, orientándolos
        hacia la satisfacción de la comunidad tecnológica, el uso racional de los recursos y el cumplimiento de
        los requisitos legales aplicables, mediante la implementación y difusión de objetivos y acciones para
        prevenir y reducir la contaminación, accidentes y enfermedades de trabajo a través de la mejora continua
        y eficacia de los Sistemas de Gestión, conforme a las Normas ISO 9001, ISO 14001 e ISO 45001, así como
        promoviendo la igualdad de oportunidades, mediante la Norma Mexicana NMX-R-025-SCFI-2015.
      </p>

    </div>

  </div>

</section>